import {IColorChangeable} from '../../Interfaces';

declare let THREE: any;

export class Mesh extends (THREE.LineSegments as { new(geomerty, material): any; }) implements IColorChangeable {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(90));
  static readonly Name = 'Circle';

  constructor() {
    const geometry = new THREE.EdgesGeometry(new THREE.CircleBufferGeometry(1, 64).applyMatrix(Mesh.rotationTransform));
    const material = new THREE.LineBasicMaterial({color: 0x000000});
    super(geometry, material);
    this.name = Mesh.Name;
  }

  setColor(color): void {
    this.material.color.copy(color);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Circle/Mesh.ts